import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const EmptyState = ({ icon = '📭', title, description, action, sx = {} }) => (
  <Box sx={{ textAlign: 'center', py: 8, px: 3, ...sx }}>
    <Typography sx={{ fontSize: 48, mb: 2 }}>{icon}</Typography>
    {title && (
      <Typography variant="h4" sx={{ mb: 1 }}>
        {title}
      </Typography>
    )}
    {description && (
      <Typography variant="body2" sx={{ maxWidth: 360, mx: 'auto', mb: 3, fontWeight: 300 }}>
        {description}
      </Typography>
    )}
    {action}
  </Box>
);

export default EmptyState;
